import { all, takeEvery } from "redux-saga/effects";
import { createAction } from "typesafe-actions";
import { AuthActionTypes } from "./types";

export const authAsync = createAction(
  AuthActionTypes.AUTH_REQUEST,
  (payload) => payload
)();

export const logoutAsync = createAction(
  AuthActionTypes.USER_LOGOUT,
  () => { }
)();

export function* authSaga() {
  yield all([
    takeEvery(AuthActionTypes.AUTH_REQUEST, authAsync),
    takeEvery(AuthActionTypes.USER_LOGOUT, logoutAsync),
  ]);
}
